import React from 'react';
import { Copy, Eye } from 'lucide-react';

const aspectClass = {
  tall: 'aspect-[3/4]',
  square: 'aspect-square',
  wide: 'aspect-[4/3]',
};

const fmt = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n}`);

// Static masonry grid with hover overlay (used on /gallery and landing preview)
export default function MasonryGallery({ items, onClone }) {
  return (
    <div className="columns-2 gap-4 md:columns-3 lg:columns-4 [column-fill:_balance]">
      {items.map((item, i) => (
        <figure
          key={item.id}
          className="group relative mb-4 break-inside-avoid overflow-hidden rounded-xl border border-border bg-card"
          style={{ animationDelay: `${(i % 8) * 60}ms` }}
        >
          <div className={`w-full overflow-hidden ${aspectClass[item.aspect] || 'aspect-square'}`}>
            <img
              src={item.src}
              alt={item.title}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </div>
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          <figcaption className="absolute inset-x-0 bottom-0 z-10 translate-y-2 p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
            <div className="flex items-end justify-between gap-2">
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-white">{item.title}</p>
                {(typeof item.clones === 'number' || typeof item.views === 'number') && (
                  <div className="mt-1 flex items-center gap-3 text-[11px] text-white/60">
                    {typeof item.clones === 'number' && <span className="inline-flex items-center gap-1"><Copy size={11} /> {fmt(item.clones)}</span>}
                    {typeof item.views === 'number' && <span className="inline-flex items-center gap-1"><Eye size={11} /> {fmt(item.views)}</span>}
                  </div>
                )}
              </div>
              <button
                onClick={() => onClone && onClone(item)}
                className="pointer-events-auto shrink-0 rounded-full bg-white px-3 py-1.5 text-xs font-medium text-black transition-transform hover:scale-105"
              >
                Clone
              </button>
            </div>
          </figcaption>
          <span className="absolute left-3 top-3 z-10 rounded-full border border-white/15 bg-black/50 px-2 py-0.5 text-[10px] uppercase tracking-wider text-white/80 backdrop-blur-sm">
            {item.vertical}
          </span>
        </figure>
      ))}
    </div>
  );
}
